
// Import exhibits from separate files
import { artExhibits } from './exhibits/artExhibits';
import { ancientExhibits } from './exhibits/ancientExhibits';
import { outdoorSculptureExhibits } from './exhibits/outdoorSculptureExhibits';
import { photographyExhibits } from './exhibits/photographyExhibits';
import { cityLandmarkExhibits } from './exhibits/cityLandmarkExhibits';
import { Exhibit } from './types';

// Combine all exhibits for export
export const exhibits: Exhibit[] = [
  ...artExhibits,
  ...ancientExhibits,
  ...outdoorSculptureExhibits,
  ...photographyExhibits,
  ...cityLandmarkExhibits
];

// Export the individual categories as well for more granular access
export {
  artExhibits,
  ancientExhibits,
  outdoorSculptureExhibits,
  photographyExhibits,
  cityLandmarkExhibits
};
